const requests = new WeakMap();
let sessionRevision = 0;

export const invalidateProfileReads = () => {
  sessionRevision += 1;
};

export const captureProfileSession = ({ state, rootGetters }) => {
  const revision = sessionRevision;
  const userId = state.currentUser.id;
  const accountId = rootGetters.getCurrentAccountId;
  return () =>
    sessionRevision === revision &&
    state.currentUser.id === userId &&
    rootGetters.getCurrentAccountId === accountId;
};

export const captureProfileRead = context => {
  const request = requests.get(context.state);
  const sameSession = captureProfileSession(context);
  return () => requests.get(context.state) === request && sameSession();
};

export const completeProfileRead = context => {
  requests.set(context.state, Symbol());
};

export const startProfileRead = context => {
  completeProfileRead(context);
  return captureProfileRead(context);
};

const newestReads = new WeakMap();

export const trackProfileRead = (context, read) => {
  newestReads.set(context.state, read);
  return read;
};

// Result of the newest profile read once reads stop superseding each other;
// null when no read is newer than `superseded`.
export const settleProfileReads = async (context, superseded) => {
  const read = newestReads.get(context.state);
  if (!read || read === superseded) return null;
  const result = await read;
  return result === null ? settleProfileReads(context, read) : result;
};
